'use client';

import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.Trigger;

const CollapsibleContent = CollapsiblePrimitive.Panel;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
